import { GetContainer } from "rc-util/lib/PortalWrapper";
import { createContext } from "react";

const GetLayoutContainerContext = createContext<GetContainer | null>(null);
export default GetLayoutContainerContext;
